import { FeedSettingsContainer } from '../containers/FeedSettingsContainer';
import { FeedTypes } from '../service/feed.interface';

export const options: Array<{ value: FeedTypes; label: string }> = [
    {
        value: FeedTypes.yml,
        label: 'Яндекс',
    },
    {
        value: FeedTypes.fileYml,
        label: 'Яндекс (файл/yml)',
    },
    {
        value: FeedTypes.csvGoogleMerchant,
        label: 'Google Merchant',
    },
    {
        value: FeedTypes.wildberries,
        label: 'Wildberries',
    },
];

export const initial = {
    feed_frequency: 24,
    feed_url: undefined,
    is_active: true,
    type: undefined,
};

export const messages = {
    pageTitle: 'Настройка фида',
    hint: 'Система принимает фиды в формате yml.',
};

export const items = [
    {
        key: '1',
        label: 'Настройка',
        children: <FeedSettingsContainer />,
    },
];
